export default "__VITE_ASSET__5d21e44f__"